import { useState, useEffect } from 'react';
import { getAnniversairesEquipe } from '../api';

/** Bandeau des anniversaires du jour : visible de toute l'équipe, notifications activées ou non. */
export default function BandeauAnniversaires() {
  const [liste, setListe] = useState([]);
  useEffect(() => { getAnniversairesEquipe().then(r => setListe(r.anniversaires || [])).catch(() => {}); }, []);
  if (!liste.length) return null;
  const moi = liste.find(a => a.moi);
  const autres = liste.filter(a => !a.moi).map(a => `${a.prenom}${a.initiale ? ` ${a.initiale}.` : ''}`);
  const enumerer = l => l.length > 1 ? `${l.slice(0, -1).join(', ')} et ${l[l.length - 1]}` : l[0];
  return (
    <div className="card" role="status" style={{ marginBottom:14, borderColor:'var(--accent)', background:'rgba(var(--accent-rgb),0.08)', display:'flex', gap:12, alignItems:'center' }}>
      <div style={{ fontSize:30, lineHeight:1 }} aria-hidden="true">🎂</div>
      <div style={{ fontSize:14, lineHeight:1.5 }}>
        {moi && <div><b>Joyeux anniversaire {moi.prenom} !</b> Toute l'équipe te souhaite une belle journée.</div>}
        {autres.length > 0 && <div>C'est l'anniversaire de <b>{enumerer(autres)}</b> aujourd'hui : pense à {autres.length > 1 ? 'le leur' : 'le lui'} souhaiter !</div>}
      </div>
    </div>);
}
